


























import { Component, Prop, Vue } from "vue-property-decorator";
import TextLink from "@/common/components/atoms/TextLink.vue";
import HContainer from "@/general/components/pages/parts/PointHistoryList/HContainer.vue";
import HBorderPanel from "@/general/components/pages/parts/PointHistoryList/HBorderPanel.vue";

@Component({
  components: {
    TextLink,
    HContainer,
    HBorderPanel
  }
})
export default class HDeliveryDetails extends Vue {
  @Prop({ type: [Object, Boolean], default: false }) courier!:
    | any
    | undefined
    | boolean;

  get courierDetail(): any {
    return this.courier
      ? [
          {
            label: "配送日",
            detail: [this.courier.date]
          },
          {
            label: "配送業者名",
            detail: [this.courier.company_name]
          },
          {
            label: "問い合わせ荷物番号",
            detail: [this.courier.reference_package_number]
          }
        ]
      : false;
  }
}
